import $ from 'jquery';

const $eventFormEl = $('.event-form');

$(function () {
    if ($eventFormEl.length > 0) {
        $eventFormEl.on('click', '#frm-advertising-UniverzitniWeb', function () {
            if ($(this).is(':checked') || $('#frm-advertising-Intranet').is(':checked')) {
                if (! $('.event-form__post').is(':visible')) {
                    $('.event-form__post').toggle();
                }
            } else {
                if ($('.event-form__post').is(':visible')) {
                    $('.event-form__post').toggle();
                }
            }          
        });

        $eventFormEl.on('click', '#frm-advertising-Intranet', function () {
            if ($(this).is(':checked') || $('#frm-advertising-UniverzitniWeb').is(':checked')) {
                if (! $('.event-form__post').is(':visible')) {
                    $('.event-form__post').toggle();
                }
            } else {
                if ($('.event-form__post').is(':visible')) {
                    $('.event-form__post').toggle();
                }
            }
          
        });
    }
});